import { render, staticRenderFns } from "./AccordionComponent.vue?vue&type=template&id=2392b6c8&scoped=true"
import script from "./AccordionComponent.vue?vue&type=script&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392b6c8",
  null
  
)

export default component.exports